import styled, { css } from "styled-components";
import Typography from "./core/typography";

const Spinner = ({
  margin = [24, 24, 24, 24],
  label = "",
  size = "default",
  testId = "spinner",
}) => {
  return (
    <SpinnerWrapper margin={margin} size={size} data-testid={testId}>
      <img src="/spinner.svg" alt="Loading" />
      {label && <Typography textAlign="center">{label}</Typography>}
    </SpinnerWrapper>
  );
};

const SpinnerWrapper = styled.div`
  img {
    display: block;
    width: 64px;
    height: 64px;
    margin: 0 auto 32px auto;
    ${(props) =>
      props.size === "small" &&
      css`
        width: 24px;
        height: 24px;
        margin: 2px 0;
        opacity: 0.33;
      `}
  }
  p {
    color: #999;
  }
  ${(props) =>
    props.margin &&
    css`
      margin-top: ${props.margin[0]}px;
      margin-right: ${props.margin[1]}px;
      margin-bottom: ${props.margin[2]}px;
      margin-left: ${props.margin[3]}px;
    `}
`;

export default Spinner;
